import TCSBrand from "./tcsBrand.navbar.component";
import NavLink from "./navLink.navbar.component";
import LogoutButton from "../buttons/logout.button";
import useLogout from "../../hooks/users/useLogout";
import NavDropdown from "./navDropdown";

const DEFAULT_CLASSNAMES = {
  dropdown: {
    navLink: {
      container:
        "decoration-primary uppercase bg-slate-100 cursor-pointer hover:underline text-secondary font-ubuntuRegular rounded px-2 py-1 flex items-center",
      currentContainer:
        "decoration-primary text-primary uppercase border-animate cursor-pointer underline font-ubuntuRegular bg-slate-100 rounded px-2 py-1 flex items-center",
    },
  },
};

const NAVLINKS = [
  // {
  //   label: "Admin",
  //   type: "link",
  //   to: "/admin",
  // },
  {
    label: "Assets",
    type: "link",
    to: "/assets",
  },
  {
    label: "Parts",
    type: "dropdown",
    children: [
      {
        label: "Open",
        to: "/parts/open",
        classNames: DEFAULT_CLASSNAMES.dropdown.navLink,
      },
      {
        label: "Ordered",
        to: "/parts/ordered",
        classNames: DEFAULT_CLASSNAMES.dropdown.navLink,
      },
    ],
  },
  {
    label: "Products",
    to: "/products",
    type: "link",
  },
  {
    label: "Reports",
    to: "/reports",
    type: "link",
  },
  {
    label: "Tickets",
    to: "/tickets",
    type: "link",
  },
  {
    label: "Shipping",
    to: "/shipping",
    type: "link",
  },
  {
    label: "STATEMENTS",
    to: "/statements",
    type: "link",
  },
  {
    label: "Users",
    type: "link",
    to: "/users",
  },
];

const Navbar = () => {
  const logout = useLogout;
  return (
    <nav className="bg-secondary p-4 fixed top-0 w-full z-10 h-[72px]">
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          <TCSBrand />
          <div className="flex gap-2 uppercase">
            {NAVLINKS.map((navLink, index) =>
              navLink.type === "dropdown" ? (
                <NavDropdown
                  key={`${navLink.label}-${index}`}
                  label={navLink.label}
                >
                  {navLink.children.map((navLink, index) => (
                    <NavLink
                      key={`${navLink.label}-${index}`}
                      to={navLink?.to}
                      classNames={navLink?.classNames}
                    >
                      {navLink.label}
                    </NavLink>
                  ))}
                </NavDropdown>
              ) : (
                <NavLink
                  key={`${navLink.label}-${index}`}
                  to={navLink?.to}
                  classNames={navLink?.classNames}
                >
                  {navLink.label}
                </NavLink>
              )
            )}
            <LogoutButton onLogout={logout} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
